<template>
  <div
    v-if="option && style"
    class="style-option-preview"
  >
    <div
      class="style-option-preview__image"
      :style="`background-image: url('${imageUrl}')`"
    />
    <span class="style-option-preview__name">{{ style.name }}</span>
    <span
      v-if="meta"
      class="style-option-preview__tags"
    >
      <span
        v-for="(value, valueIndex) in meta"
        :key="valueIndex"
        class="style-option-preview__tag"
      >
        {{ value }}
      </span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { imageResolutions } from '@/constants/image.js'
import Utils from '@/services/utils.js'

import { S3Trim } from '@/mixins/s3Trim.js'

export default {
  name: 'StyleOptionPreview',

  mixins: [S3Trim],

  props: {
    styleId: Number,
    optionId: Number
  },

  data: () => ({}),

  computed: {
    ...mapGetters(['getOptionById', 'getStyleById']),

    /**
     * @returns {object}
     */
    style () {
      return this.getStyleById(this.styleId)
    },

    /**
     * @returns {object}
     */
    option () {
      return this.getOptionById(this.optionId)
    },

    /**
     * @returns {string}
     */
    imageUrl () {
      return this.getImageUrl(imageResolutions.STYLE)
    },

    /**
     * @returns {object}
     */
    meta () {
      return Utils.parseStyleMetaNames(this.style)
    }
  },

  methods: {
    /**
     * @param   {string}        [resolution=imageResolutions.STYLE]
     *
     * @returns {string | null}
     */
    getImageUrl (resolution = imageResolutions.STYLE) {
      if (this.option.assets_file) {
        return this.s3Trim(this.option.assets_file, resolution)
      } else {
        return require('../../assets/images/shirt-placeholder.png')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.style-option-preview {
  @include size(100%);

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: $spacer-unit;
  text-align: center;
  background-color: $white;
  border-radius: $border-radius-default;
  box-shadow: $shadow-default;
}

.style-option-preview__image {
  @include size(100%, 80%);

  margin-bottom: $spacer-unit;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.style-option-preview__name {
  @include text-ellipsis(100%);

  margin-bottom: $spacer-unit;
  color: $grey;
  text-transform: uppercase;
}

.style-option-preview__tags {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  font-size: $font-size-medium;
}

.style-option-preview__tag {
  margin-right: $spacer-unit;

  &:last-of-type {
    margin-right: 0;
  }
}
</style>
